'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_api_CreateGeneralPracticeRequest$PracticeData(name, address, postcode, contactPerson, contactPhone, contactEmail) {
  this.Lapp_api_CreateGeneralPracticeRequest$PracticeData__f_name = null;
  this.Lapp_api_CreateGeneralPracticeRequest$PracticeData__f_address = null;
  this.Lapp_api_CreateGeneralPracticeRequest$PracticeData__f_postcode = null;
  this.Lapp_api_CreateGeneralPracticeRequest$PracticeData__f_contactPerson = null;
  this.Lapp_api_CreateGeneralPracticeRequest$PracticeData__f_contactPhone = null;
  this.Lapp_api_CreateGeneralPracticeRequest$PracticeData__f_contactEmail = null;
  this.Lapp_api_CreateGeneralPracticeRequest$PracticeData__f_name = name;
  this.Lapp_api_CreateGeneralPracticeRequest$PracticeData__f_address = address;
  this.Lapp_api_CreateGeneralPracticeRequest$PracticeData__f_postcode = postcode;
  this.Lapp_api_CreateGeneralPracticeRequest$PracticeData__f_contactPerson = contactPerson;
  this.Lapp_api_CreateGeneralPracticeRequest$PracticeData__f_contactPhone = contactPhone;
  this.Lapp_api_CreateGeneralPracticeRequest$PracticeData__f_contactEmail = contactEmail;
}
export { $c_Lapp_api_CreateGeneralPracticeRequest$PracticeData as $c_Lapp_api_CreateGeneralPracticeRequest$PracticeData };
$c_Lapp_api_CreateGeneralPracticeRequest$PracticeData.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_api_CreateGeneralPracticeRequest$PracticeData.prototype.constructor = $c_Lapp_api_CreateGeneralPracticeRequest$PracticeData;
/** @constructor */
function $h_Lapp_api_CreateGeneralPracticeRequest$PracticeData() {
}
export { $h_Lapp_api_CreateGeneralPracticeRequest$PracticeData as $h_Lapp_api_CreateGeneralPracticeRequest$PracticeData };
$h_Lapp_api_CreateGeneralPracticeRequest$PracticeData.prototype = $c_Lapp_api_CreateGeneralPracticeRequest$PracticeData.prototype;
$c_Lapp_api_CreateGeneralPracticeRequest$PracticeData.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lapp_api_CreateGeneralPracticeRequest$PracticeData.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 1712666396, true);
});
$c_Lapp_api_CreateGeneralPracticeRequest$PracticeData.prototype.equals__O__Z = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lapp_api_CreateGeneralPracticeRequest$PracticeData) && ((((((this.Lapp_api_CreateGeneralPracticeRequest$PracticeData__f_name === x$0.Lapp_api_CreateGeneralPracticeRequest$PracticeData__f_name) && (this.Lapp_api_CreateGeneralPracticeRequest$PracticeData__f_address === x$0.Lapp_api_CreateGeneralPracticeRequest$PracticeData__f_address)) && (this.Lapp_api_CreateGeneralPracticeRequest$PracticeData__f_postcode === x$0.Lapp_api_CreateGeneralPracticeRequest$PracticeData__f_postcode)) && (this.Lapp_api_CreateGeneralPracticeRequest$PracticeData__f_contactPerson === x$0.Lapp_api_CreateGeneralPracticeRequest$PracticeData__f_contactPerson)) && (this.Lapp_api_CreateGeneralPracticeRequest$PracticeData__f_contactPhone === x$0.Lapp_api_CreateGeneralPracticeRequest$PracticeData__f_contactPhone)) && (this.Lapp_api_CreateGeneralPracticeRequest$PracticeData__f_contactEmail === x$0.Lapp_api_CreateGeneralPracticeRequest$PracticeData__f_contactEmail))));
});
$c_Lapp_api_CreateGeneralPracticeRequest$PracticeData.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lapp_api_CreateGeneralPracticeRequest$PracticeData.prototype.productArity__I = (function() {
  return 6;
});
$c_Lapp_api_CreateGeneralPracticeRequest$PracticeData.prototype.productPrefix__T = (function() {
  return "PracticeData";
});
$c_Lapp_api_CreateGeneralPracticeRequest$PracticeData.prototype.productElement__I__O = (function(n) {
  switch (n) {
    case 0: {
      return this.Lapp_api_CreateGeneralPracticeRequest$PracticeData__f_name;
      break;
    }
    case 1: {
      return this.Lapp_api_CreateGeneralPracticeRequest$PracticeData__f_address;
      break;
    }
    case 2: {
      return this.Lapp_api_CreateGeneralPracticeRequest$PracticeData__f_postcode;
      break;
    }
    case 3: {
      return this.Lapp_api_CreateGeneralPracticeRequest$PracticeData__f_contactPerson;
      break;
    }
    case 4: {
      return this.Lapp_api_CreateGeneralPracticeRequest$PracticeData__f_contactPhone;
      break;
    }
    case 5: {
      return this.Lapp_api_CreateGeneralPracticeRequest$PracticeData__f_contactEmail;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$c_Lapp_api_CreateGeneralPracticeRequest$PracticeData.prototype.productElementName__I__T = (function(n) {
  switch (n) {
    case 0: {
      return "name";
      break;
    }
    case 1: {
      return "address";
      break;
    }
    case 2: {
      return "postcode";
      break;
    }
    case 3: {
      return "contactPerson";
      break;
    }
    case 4: {
      return "contactPhone";
      break;
    }
    case 5: {
      return "contactEmail";
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lapp_api_CreateGeneralPracticeRequest$PracticeData(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lapp_api_CreateGeneralPracticeRequest$PracticeData)));
}
export { $isArrayOf_Lapp_api_CreateGeneralPracticeRequest$PracticeData as $isArrayOf_Lapp_api_CreateGeneralPracticeRequest$PracticeData };
var $d_Lapp_api_CreateGeneralPracticeRequest$PracticeData = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_api_CreateGeneralPracticeRequest$PracticeData, "app.api.CreateGeneralPracticeRequest$PracticeData", ({
  Lapp_api_CreateGeneralPracticeRequest$PracticeData: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lapp_api_CreateGeneralPracticeRequest$PracticeData as $d_Lapp_api_CreateGeneralPracticeRequest$PracticeData };
//# sourceMappingURL=app.api.-Create-General-Practice-Request$-Practice-Data.js.map
